/**
 * Build the omnisearch `shippedDate:` range token for a single- or double-ended
 * filter: `a..b`, `a..` (start-only), `..b` (end-only), or `null` when neither
 * bound is set. Callers pick the no-bounds fallback — the stream detail grid
 * uses the current year, the compare dialog shows all time.
 */
export function buildShippedDateRangeToken(startDate?: string, endDate?: string): string | null {
  if (startDate && endDate) return `${startDate}..${endDate}`;
  if (startDate) return `${startDate}..`;
  if (endDate) return `..${endDate}`;
  return null;
}
